import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/diet-settings/nutritionSettings/',
    redirectTo: '/diet-settings/nutritionSettings/diet-type',
  },
];

export default redirects;
